module.exports = __webpack_public_path__ + "img/layout-alt-02.0016d722.svg";